import React from 'react';
import PropTypes from 'prop-types';
import EntriesList from './EntriesList';

const Entries = (props) => {
    const { params: { type }, data } = props;
    const isJockey = type === 'jockey';
    const isHorseShown = type !== 'horse';
    const entries = (isJockey ? data.bookedRides : data.entries) || [];
    const title = isJockey ? 'booked rides' : 'entries';
    const horseName = isHorseShown ? null : data.profile.horseName;

    return (
        <section>
            <EntriesList
                entries={entries}
                horseName={horseName}
                noDataText={`No ${title} for this ${type}`}
                isHorseShown={isHorseShown}
                isPriceShown
                isDamShown={false}
            />
        </section>
    );
};

const entriesTypes = PropTypes.arrayOf(PropTypes.shape({
    courseStyleName: PropTypes.string,
    courseUid: PropTypes.number,
    horseName: PropTypes.string,
    horseUid: PropTypes.number,
    raceDatetime: PropTypes.string,
    raceInstanceTitle: PropTypes.string,
    raceInstanceUid: PropTypes.number,
    raceStatusCode: PropTypes.string,
    raceUid: PropTypes.number,
}));

Entries.propTypes = {
    data: PropTypes.shape({
        entries: entriesTypes,
        bookedRides: entriesTypes,
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
    }).isRequired,
};

export default Entries;



// WEBPACK FOOTER //
// ./src/js/shared/entries/Entries.jsx